import { render, staticRenderFns } from "./DefectDistribution.vue?vue&type=template&id=290eb2c2&"
import script from "./DefectDistribution.vue?vue&type=script&lang=js&"
export * from "./DefectDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports